import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { PictureAsPdf } from "@mui/icons-material";
import { Alert, TextField } from "@mui/material";
import FileDropzone from "components/common/dropzone/Dropzone";
import React from "react";
import { useSelector } from "react-redux";
import { getNumberInputValue } from "utils/number";

const InsertPage = (props) => {
  const {
    onCancel,
    handleFileUpload,
    setNewPagePosition,
    isReportNoteEditMode,
    setNewPageAfterPageNumber,

    newPagePosition,
    originalPDFTotalPages,
    newPageAfterPageNumber,
  } = props;
  const {
    fileToAttachToReport,
    fileToAttachSelected,
    fileToAttachToReportName,
  } = useSelector((state) => state.transmission);

  return (
    <div
      style={{
        boxSizing: "border-box",
        width: "100%",
        position: "relative",
      }}
    >
      <FormControl className="mb-2">
        <RadioGroup
          row
          aria-labelledby="demo-row-radio-buttons-group-label"
          name="row-radio-buttons-group"
          defaultValue="existing"
          value={newPagePosition ?? "start"}
          onChange={(e) => {
            const value = e.target.value;
            setNewPagePosition(value);
            onCancel();
          }}
        >
          <FormControlLabel
            value="end"
            control={<Radio />}
            label="Insert page at end"
          />
          <FormControlLabel
            value="start"
            control={<Radio />}
            label="Insert page at start"
          />
          <FormControlLabel
            value="page"
            control={<Radio />}
            label={
              <Box display="flex" alignItems="center">
                Insert page after:
                <TextField
                  type="number"
                  variant="outlined"
                  size="small"
                  disabled={newPagePosition !== "page" || fileToAttachSelected}
                  style={{ marginLeft: 10, width: 65 }}
                  value={newPageAfterPageNumber}
                  onChange={(e) => {
                    const value = e.target.value;
                    const pageNumber = getNumberInputValue(value);
                    if (pageNumber <= originalPDFTotalPages) {
                      setNewPageAfterPageNumber(pageNumber);
                    }
                  }}
                  inputProps={{ min: 1 }}
                />
                {originalPDFTotalPages > 0 && newPagePosition === "page" && (
                  <Box marginLeft={1}>of {originalPDFTotalPages}</Box>
                )}
              </Box>
            }
          />
        </RadioGroup>
      </FormControl>

      {newPagePosition !== "end" && !isReportNoteEditMode && (
        <Alert severity="warning" className="mt-3 mb-3">
          Inserting page here will automatically update page numbers of linked
          pages.
        </Alert>
      )}
      {isReportNoteEditMode && (
        <Alert severity="error" className="mt-3 mb-3">
          Save the report notes before inserting page.
        </Alert>
      )}

      {!fileToAttachSelected && (
        <FileDropzone
          onDrop={handleFileUpload}
          multiple={true}
          allowedFileTypes={[".pdf"]}
          style={{
            height: "300px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
          fileSizeLimit="5MB"
          content={
            <span>
              <p>Drag and drop a PDF file here</p>
              <p>or</p>
            </span>
          }
        />
      )}

      {fileToAttachSelected && (
        <div>
          <div className="d-flex justify-between mb-2 align-center">
            <div className="d-flex align-center">
              <h3 className="mr-1 mb-0">Selected File:</h3>
              <p
                key={fileToAttachToReportName}
                className="d-flex align-center ml-1 mb-0"
              >
                <PictureAsPdf style={{ color: "#949494" }} />
                <span className="ml-2" style={{ fontSize: "16px" }}>
                  {fileToAttachToReport?.fileName?.replace(
                    /-?\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}$/,
                    ""
                  )}
                </span>
              </p>
            </div>
            <Button variant="outlined" color="secondary" onClick={onCancel}>
              Replace file
            </Button>
          </div>

          {fileToAttachSelected && (
            <embed
              src={fileToAttachToReport.pdfUrl}
              type="application/pdf"
              style={{
                width: "100%",
                height: "100vh",
              }}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default InsertPage;
